import { Box, Container, Grid, GridItem } from '@chakra-ui/react';

import ErrorAlert from '@/client/components/data-display/ErrorAlert';
import LearnerProfileAccountSettingsFormModal from './overlay/LearnerProfileAccountSettingsFormModal';
import LearnerProfileActivityFeed from './LearnerProfileActivityFeed';
import LearnerProfileAvatar from './avatar/LearnerProfileAvatar';
import LearnerProfileHero from './LearnerProfileHero';
import LearnerProfileUserDetails from './user-details/LearnerProfileUserDetails';
import LearnerProfileUserDetailsFormModal from './overlay/LearnerProfileUserDetailsFormModal';
import Loading from '@/client/components/media/Loading';
import User from '@/client/services/api/User';
import { useAuthStore } from '@/client/services/state/authStore';
import { useEffect } from 'react';
import { useLearnerProfileStore } from './state/learnerProfileStore';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

// TODO: Loading state
// TODO: Error state

export default function LearnerProfile() {
  const { t } = useTranslation();
  const { id } = useParams();
  const { authConfig } = useAuthStore();
  const { user } = authConfig;
  const { setIsActiveUser, userDetailsModalIsOpen, accountSettingsModalIsOpen } =
    useLearnerProfileStore();

  const userId = id || user._id;

  const isActiveUser = !id || id === user._id;

  useEffect(() => {
    setIsActiveUser(isActiveUser);
  }, [isActiveUser]);

  const {
    data: userData,
    isLoading: isUserDataLoading,
    isError: isUserDataError,
  } = useQuery({
    queryKey: ['learner-profile-user-data', userId, isActiveUser],
    queryFn: () => User.getUser(userId),
  });

  const gridItemStyles = {
    backgroundColor: 'white',
    border: '1px solid',
    borderColor: 'neutral.100',
    borderRadius: '16px',
    padding: 6,
  };

  if (isUserDataLoading) return <Loading />;

  if (isUserDataError) return <ErrorAlert title={t('learners.profile.error')} />;

  return (
    <Box backgroundColor="neutral.0" minHeight="calc(100vh - 50px)" paddingBottom={10}>
      <LearnerProfileHero userData={userData} />

      <Container maxWidth="container.xl" paddingTop={4}>
        <LearnerProfileAvatar userData={userData} />

        <Grid
          templateColumns={{ base: 'repeat(1, 1fr)', lg: 'repeat(12, 1fr)' }}
          gap={12}
          marginTop={16}
          maxWidth="100%"
        >
          <GridItem colSpan={{ base: 1, lg: 8 }} sx={gridItemStyles}>
            <LearnerProfileUserDetails userData={userData} />
          </GridItem>

          <GridItem colSpan={{ base: 1, lg: 4 }} sx={gridItemStyles} height="fit-content">
            <LearnerProfileActivityFeed userData={userData} />
          </GridItem>
        </Grid>
      </Container>

      {isActiveUser && (
        <>
          {accountSettingsModalIsOpen && <LearnerProfileAccountSettingsFormModal />}

          {userDetailsModalIsOpen && <LearnerProfileUserDetailsFormModal userData={userData} />}
        </>
      )}
    </Box>
  );
}
